import React from 'react';
import {useForm} from "@inertiajs/inertia-react";
import {useDispatch} from "react-redux";
import {closeModal} from "@/Store/Slices/ModalSlice";

const UnpublishMerchant = () => {
  const {put} = useForm({ id: id });
  const dispatch = useDispatch();

  const handleUnpublished = () => {
    put(route('public.merchants.unpublished', id).url());
    dispatch(closeModal());
  }

  return (
    <>
      <div className="modal-body">
        Do you want remove this merchant from online?
      </div>
      <div className="modal-footer flex justify-end">
        <button onClick={handleUnpublished} className="btn-default bg-green-700 focus:outline-none py-2 px-4">
          <span>Yes</span>
        </button>
      </div>
    </>
  );
};

export default UnpublishMerchant;
